import { Product } from '@/models/Product';
import { CheckoutStepType, ReceiverInfoStep } from '@/lib/checkoutRoutes';
import { Basket, BasketItem } from '@/models/Basket';
import { defaultMetaData } from './Constants';

export enum GTMEventType {
  VIEW_ITEM = 'view_item',
  VIEW_ITEM_LIST = 'view_item_list',
  SELECT_ITEM = 'select_item',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_CART = 'view_cart',
  SEARCH = 'search',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  ADD_CARD_MESSAGE = 'add_card_message',
  ADD_PAYMENT_INFO = 'add_payment_info',
  FORM_SUBMIT = 'form_submit',
  PURCHASE = 'purchase',
  EXCEPTION = 'exception',
  LOGIN_SUCCESS = 'login_success',
  REGISTER_SUCCESS = 'register_success',
  PAGE_VIEW = 'page_view',
}

export const FACEBOOK_EVENT_MAP: Record<string, string> = {
  view_item: 'ViewContent',
  view_item_list: 'ViewContent',
  select_item: 'SelectContent',
  add_to_cart: 'AddToCart',
  remove_from_cart: 'RemoveFromCart',
  begin_checkout: 'InitiateCheckout',
  add_payment_info: 'AddPaymentInfo',
  purchase: 'Purchase',
  search: 'Search',
  add_shipping_info: 'AddShippingInfo',
  generate_lead: 'Lead',
  sign_up: 'CompleteRegistration',
  login: 'Login',
  // GTM'de özel olanlar burada trackCustom yapılabilir istersen
};

export function getEcommerceBody(products: Product[], total: number | undefined) {
  return {
    currency: 'TRY',
    value: total || products?.[0].price || 0,
    items: [
      ...products.map((product) => ({
        ...getEcommerceProductItem(product),
        quantity: 1,
      })),
    ],
  };
}

export function getEcommerceBodyForListItems(
  products: Product[],
  listId: string,
  listName: string,
) {
  return {
    item_list_id: listId,
    item_list_name: listName,
    items: [
      ...products.map((product) => ({
        ...getEcommerceProductItem(product),
        quantity: 1,
      })),
    ],
  };
}

export function getBasketEcommerceBody(basket: Basket) {
  const data = {
    currency: 'TRY',
    value: basket.total,
    items: [
      ...basket.items.map((product, index) => {
        const categories = {};
        product.categoryNames?.slice(0, 10).map((name, index) => {
          if (index > 0) {
            categories['item_category' + (index + 1)] = name;
          }
        });

        return {
          item_name: product.title,
          item_id: product.id,
          item_brand: defaultMetaData.brand,
          price: product.price,
          item_category: product.categoryNames?.[0] || '',
          index: index,
          quantity: product.count,
          ...categories,
          item_list_id: product.categoryIds?.[0]?.toString() || '',
          item_list_name: product.categoryNames?.[0] || '',
        };
      }),
    ],
  };

  if (basket.promoCode) {
    data['coupon'] = basket.promoCode;
  }

  return data;
}

export function getBasketEcommerceBodyForProduct(
  products: BasketItem[],
  total: number | undefined,
) {
  return {
    currency: 'TRY',
    value: total || products?.[0].price || 0,
    items: [
      ...products.map((product, index) => {
        const categories = {};
        product.categoryNames?.slice(0, 10).map((name, index) => {
          if (index > 0) {
            categories['item_category' + (index + 1)] = name;
          }
        });

        return {
          item_id: product.id,
          item_name: product.title,
          item_brand: defaultMetaData.brand,
          price: product.price,
          item_category: product.categoryNames?.[0] || '',
          index: index,
          quantity: product.count,
          ...categories,
          item_list_id: product.categoryIds?.[0]?.toString() || '',
          item_list_name: product.categoryNames?.[0] || '',
        };
      }),
    ],
  };
}

export function getEventNameFromCheckoutStep(
  step: CheckoutStepType,
  receiverInfoStep: ReceiverInfoStep,
) {
  let result = '';
  if (step === CheckoutStepType.RECEIVER_INFO) {
    if (receiverInfoStep === ReceiverInfoStep.RECEIVER_INFO) {
      result = GTMEventType.BEGIN_CHECKOUT;
    } else if (receiverInfoStep === ReceiverInfoStep.EXTRA_PRODUCT) {
      result = GTMEventType.ADD_SHIPPING_INFO;
    } else {
      result = '';
    }
  } else if (step === CheckoutStepType.BILL_INFO) {
    result = GTMEventType.ADD_CARD_MESSAGE;
  } else {
    // result = GTMEventType.ADD_PAYMENT_INFO
  }

  return result;
}

function getEcommerceProductItem(product: Product) {
  const categories = {};
  product.categories?.slice(0, 10).map((name, index) => {
    if (index > 0) {
      categories['item_category' + (index + 1)] = name;
    }
  });

  return {
    item_id: product.id,
    item_name: product.title,
    item_brand: defaultMetaData.brand,
    price: product.price,
    item_category: product.category?.title || product.categoryName || product.categories?.[0] || '',
    index: 0,
    quantity: 1,
    ...categories,
  };
}

export function getEcommerceBodyForProduct(product: Product, listId?: string, listName?: string) {
  const categories = {};
  product.categories?.slice(0, 10).map((name, index) => {
    if (index > 0) {
      categories['item_category' + (index + 1)] = name;
    }
  });
  return {
    items: [
      {
        item_id: product.id,
        item_name: product.title,
        item_brand: defaultMetaData.brand,
        item_category:
          product.category?.title || product.categoryName || product.categories?.[0] || '',
        ...categories,
        item_list_id: listId,
        item_list_name: listName,
        price: product.price,
      },
    ],
  };
}
